import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tooltip, { POSITION } from 'gnos-tooltip'
import cx from 'classnames'
import _ from 'lodash'

import ProgressBar from '../../../../../../../../../../components/ProgressBar'
import Signals from '../../../../../../../../../../components/TableCell/components/Signals'
import ContextBurger from '../../../../../../../../../../components/ContextBurger'
import CustomDate from '../../../../../../../../../../components/CustomDate'
import Minireport from '../../../../../../../../../../components/Minireport'

import { TYPES } from '../../constants'
import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class OwnershipEntity extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        first: PropTypes.bool,
        hasBanner: PropTypes.bool,
        hasChilds: PropTypes.bool,
        hasParents: PropTypes.bool,
        identifier: PropTypes.string.isRequired,
        last: PropTypes.bool,
        listType: PropTypes.string,
        mainId: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        noHistory: PropTypes.bool,
        parentsPrimary: PropTypes.bool,
        primary: PropTypes.bool,
        relation: PropTypes.object,
        subject: PropTypes.object,
        toggledSections: PropTypes.object,
        toggleOwnershipSection: PropTypes.func.isRequired,
        translates: PropTypes.shape({
            from: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            notIdentified: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            owns: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            isOwned: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    static defaultProps = {
        primary: false,
        parentsPrimary: false,
    }

    handleToggleOwnershipSection = () => {
        const { module, block, customData, toggleOwnershipSection, identifier, mainId } = this.props

        const isOpen = _.get(customData, `toggledSections.${identifier}`, false)
        const newCustomData = {
            ...customData,
            toggledSections: {
                ...customData.toggledSections,
                [identifier]: !isOpen,
            },
        }

        toggleOwnershipSection(module, mainId, block, newCustomData)
    }

    renderParsedAddress = (address) => {
        if (_.isNil(address)) return null

        const addressParts = ['street', 'city', 'postCode', 'country']
        const addressParsed = _(addressParts)
            .map((part) => _.get(address, `${part}`, null))
            .filter((arrPart) => !_.isNil(arrPart))
            .join(', ')

        return <span>{addressParsed}</span>
    }

    render() {
        const {
            relation,
            primary,
            listType,
            first,
            identifier,
            toggledSections,
            hasChilds,
            hasBanner,
            hasParents,
            parentsPrimary,
            subject,
            last,
            translates: { notIdentified, from, owns, isOwned },
            noHistory,
        } = this.props
        const { CHILDS, PARENTS } = TYPES

        const entityId = _.get(subject, 'id', null)
        const minireport = <Minireport id={`${entityId}`} />

        return (
            <div className={cx('ownership-entity', { primary, 'has-parents': hasParents })}>
                {!hasParents && primary && (!listType || listType === PARENTS) ? null : (
                    <div
                        className={cx('border-horizontal', {
                            parents: listType === PARENTS,
                            'parents-primary': parentsPrimary,
                            first,
                        })}
                    >
                        <div
                            className={cx('top-element', {
                                primary,
                                first,
                                last,
                                'has-parents': hasParents,
                                'has-childs': hasChilds,
                                parents: listType === PARENTS,
                            })}
                        >
                            {_.isFinite(_.get(relation, 'percentage')) && relation.percentage !== 0 && (
                                <span>
                                    {listType === PARENTS ? <span>{`${owns}`}</span> : <span>{`${isOwned}`}</span>}
                                    {_.isInteger(relation.percentage)
                                        ? `${relation.percentage}%`
                                        : `${parseFloat(relation.percentage).toFixed(2)}%`}
                                </span>
                            )}
                        </div>
                        <div
                            className={cx('bottom-element', {
                                first,
                                last,
                                'no-history': noHistory,
                                'has-parents': hasParents,
                                'has-childs': hasChilds,
                                parents: listType === PARENTS,
                            })}
                        >
                            <div className={'owns-content'}>
                                <span>{`${_.get(relation, 'type', '')}`}</span>
                            </div>
                        </div>
                    </div>
                )}
                <div className={cx('ownership-entity-content', { 'parents-primary': parentsPrimary })}>
                    <div className={'content-container'}>
                        <Tooltip
                            content={minireport}
                            id={`tooltip_ownership_minireport_${entityId}`}
                            position={POSITION.TOP}
                            width={'320px'}
                            showDelay={1000}
                            doubleWrap
                        >
                            <div className={'main-content'}>
                                <div className={'icons-content'}>
                                    {!primary && (hasParents || hasBanner) && listType === PARENTS && (
                                        <div
                                            className={cx(
                                                _.get(toggledSections, identifier, false) ? 'icon-close' : 'icon-open'
                                            )}
                                            onClick={this.handleToggleOwnershipSection}
                                        />
                                    )}
                                    <div
                                        className={cx(
                                            'icon-ownership',
                                            `type-${_.get(subject, 'type', null)}`,
                                            _.get(subject, 'active', null) && 'inactive',
                                            primary && 'primary'
                                        )}
                                    >
                                        {_.get(subject, 'countryIso', null) !== 'CZ' && primary && (
                                            <div
                                                className={cx(
                                                    'flag-icon',
                                                    `flag-icon-${_.toLower(_.get(subject, 'countryIso', null))}`,
                                                    'icon-inside'
                                                )}
                                            />
                                        )}
                                    </div>
                                    {!primary && (hasChilds || hasBanner) && listType === CHILDS && (
                                        <div
                                            className={cx(
                                                _.get(toggledSections, identifier, false) ? 'icon-close' : 'icon-open'
                                            )}
                                            onClick={this.handleToggleOwnershipSection}
                                        />
                                    )}
                                </div>
                                <div className={'texts-content'}>
                                    <strong className={'entity-name'}>
                                        {_.get(subject, 'name', '')}
                                        <div className={'burger-wrapper'}>
                                            <ContextBurger entity={subject} id={_.get(subject, 'id', null)} />
                                        </div>
                                    </strong>
                                    {!primary && (
                                        <div className={'ownership-address'}>
                                            <div
                                                className={cx(
                                                    'flag-icon',
                                                    `flag-icon-${_.toLower(_.get(subject, 'countryIso', null))}`
                                                )}
                                            />
                                            {this.renderParsedAddress(_.get(subject, 'addressParsed', null))}
                                            {_.isNil(subject.addressParsed) && !_.isNil(subject.addressFull) && (
                                                <span>{`${_.get(subject, 'addressFull', '')}`}</span>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Tooltip>
                        <div className={'signals-container'}>
                            {!primary && (
                                <Signals
                                    id={_.get(subject, 'id', null)}
                                    caution={_.get(subject, 'indicators.caution', 0)}
                                    notice={_.get(subject, 'indicators.notice', 0)}
                                    risk={_.get(subject, 'indicators.risk', 0)}
                                    showZeroValues={false}
                                />
                            )}
                        </div>
                    </div>
                    {!primary && (
                        <div className={'bar-content'}>
                            {!_.isNil(_.get(relation, 'percentage', null)) &&
                                _.get(relation, 'percentage', null) !== 0 && (
                                    <ProgressBar
                                        total={100}
                                        value={
                                            _.isInteger(_.get(relation, 'percentage'))
                                                ? _.get(relation, 'percentage')
                                                : _.toNumber(parseFloat(_.get(relation, 'percentage')).toFixed(2))
                                        }
                                        hasLabel
                                        theme={'blue'}
                                        labelPostfix={'%'}
                                        threshold={null}
                                        sideOffset={3}
                                        message={
                                            _.get(relation, 'startDate.value', null) && (
                                                <span>
                                                    {from}{' '}
                                                    <CustomDate
                                                        date={relation?.startDate?.value}
                                                        precision={relation?.startDate?.precision}
                                                    />
                                                </span>
                                            )
                                        }
                                    />
                                )}
                            {_.isNil(_.get(relation, 'percentage', null)) && notIdentified}
                        </div>
                    )}
                </div>
            </div>
        )
    }
}
